import React, { useCallback, useState } from 'react'
import PropTypes from 'prop-types'
import { useDispatch } from 'react-redux'
import { Box } from '@mui/material'
import { hideModal } from '../../../redux/actions'
import ModalContainer from '../ModalContainer'

// eslint-disable-next-line import/prefer-default-export
export function DeleteOfferModal({ offer, onDelete }) {
  const dispatch = useDispatch()
  const onCancel = useCallback(() => dispatch(hideModal()), [dispatch])
  const [processing, setProcessing] = useState(false)
  return (
    <ModalContainer
      title="Delete Offer"
      modal
      maxWidth="sm"
      fullWidth="true"
      processing={processing}
      actions={{
        primaryAction: {
          label: 'Delete',
          onClick: async () => {
            setProcessing(true)
            try {
              await onDelete(offer)
            } finally {
              setProcessing(false)
            }
          },
        },
        secondaryAction: { label: 'Cancel', onClick: onCancel },
      }}
    >
      <Box>
        Are you sure you want to delete the offer? Any GOVX ID links deployed for this offer will no longer be accessible.
      </Box>
      <Box mt={2} fontWeight="bold">This action cannot be undone.</Box>
    </ModalContainer>
  )
}

DeleteOfferModal.propTypes = {
  offer: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }).isRequired,
  onDelete: PropTypes.func.isRequired,
}
